/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionWaypoint
 */
export interface InputUavMissionWaypoint {
    /**
     * 
     * @type {string}
     * @memberof InputUavMissionWaypoint
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavMissionWaypoint
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof InputUavMissionWaypoint
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof InputUavMissionWaypoint
     */
    lng: number;
}

/**
 * Check if a given object implements the InputUavMissionWaypoint interface.
 */
export function instanceOfInputUavMissionWaypoint(value: object): boolean {
    if (!('lat' in value)) return false;
    if (!('lng' in value)) return false;
    return true;
}

export function InputUavMissionWaypointFromJSON(json: any): InputUavMissionWaypoint {
    return InputUavMissionWaypointFromJSONTyped(json, false);
}

export function InputUavMissionWaypointFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionWaypoint {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': json['kind'] == null ? undefined : json['kind'],
        'label': json['label'] == null ? undefined : json['label'],
        'lat': json['lat'],
        'lng': json['lng'],
    };
}

export function InputUavMissionWaypointToJSON(value?: InputUavMissionWaypoint | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'kind': value['kind'],
        'label': value['label'],
        'lat': value['lat'],
        'lng': value['lng'],
    };
}

